import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import { classNames } from "../AppNav";
import { useTranslation } from "react-i18next";

interface SecondToolbarActionProps {
  projectId: string;
  onExport: () => void;
  /** When "deal", Import CSV link will include type=deal so Import opens with Deal mapping */
  importType?: "contact_account" | "deal";
}

export default function SecondToolbarAction({
  projectId,
  onExport,
  importType,
}: SecondToolbarActionProps) {
  const { t } = useTranslation();
  const importCsvUrl =
    importType === "deal"
      ? `/workspaces/${projectId}/settings/apps?key=Apps&appId=import_csv&type=deal`
      : importType === "contact_account"
        ? `/workspaces/${projectId}/settings/apps?key=Apps&appId=import_csv&type=contact_account`
        : `/workspaces/${projectId}/settings/apps?key=Apps&appId=import_csv`;

  return (
    <Menu as="div" className="relative inline-block text-left pt-1">
      <div>
        <MenuButton className="flex items-center rounded-full bg-gray-100 text-gray-400 hover:text-gray-600 focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100">
          <span className="sr-only">Open options</span>
          <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
        </MenuButton>
      </div>

      <MenuItems className="absolute right-0 z-50 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-opacity-5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-leave:duration-75 data-enter:ease-out data-leave:ease-in">
        <div className="py-1 w-48">
          <MenuItem>
            {({ focus }) => (
              <span
                onClick={onExport}
                className={classNames(
                  focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                  "block px-4 py-2 text-sm cursor-pointer"
                )}
              >
                {t("Export data")}
              </span>
            )}
          </MenuItem>
          <MenuItem>
            {({ focus }) => (
              <Link
                to={importCsvUrl}
                className={classNames(
                  focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                  "block px-4 py-2 text-sm cursor-pointer"
                )}
              >
                {t("Import CSV")}
              </Link>
            )}
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
}
